import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getTermList as _getTermList, updateTermInfoBySchool } from '@data/other';
export default {
  name: 'term-list',

  /* props: {
      configVo: {
          type: Object,
          default: function () {
              return {}
          }
      }
  },*/
  data: function data() {
    var paramsO = {
      startTime: '开始时间',
      endTime: '结束时间'
    }; // 设定单独的验证事件

    var checkFormItem = function checkFormItem(rule, value, callback) {
      var fieldStr = paramsO[rule.field]; // let regExp = /select|update|delete|truncate|join|union|exec|insert|drop|count|script|src|alert|window|document|location|>|<|%/i;
      // let chartLength = (value + '').replace(/[^\x00-\xff]/g, '**').length;

      if (rule.required != null && value !== 0 && (value == null || value == '')) {
        // 验证非空
        callback(new Error(fieldStr + '不能为空！'));
      } else if (rule.field === 'principalName' && value.length > 50) {
        callback(new Error('最多只能输入50个字！'));
      } else if ((rule.field === 'address' || rule.field === 'description' || rule.field === 'homePage') && value.length > 200) {
        callback(new Error('最多只能输入200个字！'));
      } else if (value.length > 40 && rule.field !== 'address' && rule.field !== 'description' && rule.field !== 'homePage' && rule.field !== 'principalName') {
        // 验证非空
        callback(new Error('最多只能输入40个字！'));
      } else {
        callback();
      }
    };

    return {
      queryVo: {
        pageNo: 1,
        pageSize: 50000
      },
      termListDao: {
        list: [],
        rowCount: 0
      },
      upTermInfoVisible: false,
      // 学期修改信息是否展示弹出框
      formLabelWidth: '100px',
      disabled: false,
      updateTermForm: {
        name: '',
        schoolYear: '',
        termType: '',
        startTime: '',
        endTime: '',
        id: '',
        currentTerm: '0',
        addOrUpdate: '',
        status: ''
      },
      updateTermFormRules: {
        name: [{
          required: true,
          validator: checkFormItem,
          trigger: 'blur'
        }],
        schoolYear: [{
          required: true,
          validator: checkFormItem,
          trigger: 'blur'
        }],
        termType: [{
          required: true,
          validator: checkFormItem,
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          validator: checkFormItem,
          trigger: 'blur'
        }],
        endTime: [{
          required: true,
          validator: checkFormItem,
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    formatTen: function formatTen(num) {
      return num > 9 ? num + '' : '0' + num;
    },
    formatDate: function formatDate(row, column) {
      var activeDate = row[column.property] || '';
      var date = new Date(activeDate);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return year + '-' + this.formatTen(month) + '-' + this.formatTen(day);
    },
    formatTimeDate: function formatTimeDate(timedate) {
      var date = new Date(timedate);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return year + '-' + this.formatTen(month) + '-' + this.formatTen(day);
    },
    getTermList: function getTermList(type) {
      var self = this;

      if (type === 1) {
        self.queryVo.pageNo = 1;
      }

      _getTermList(self.queryVo).then(function (res) {
        self.termListDao.list = res;
        self.termListDao.rowCount = res.length;
      }).catch(function () {
        self.termListDao = {
          list: [],
          rowCount: 0
        };
      });
    },
    checkboxChange: function checkboxChange(val) {
      this.updateTermForm.currentTerm = val;
    },
    checkboxDisabled: function checkboxDisabled() {
      if (this.updateTermForm.currentTerm == '1') {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryVo.pageNo = val;
      this.getTermList();
    },
    // updateTermShow 设定修改学期信息弹框展示
    updateTermShow: function updateTermShow(row) {
      var self = this;

      try {
        this.$refs['updateTermForm'].resetFields();
      } catch (Ex) {} finally {}

      row.currentTerm = row.currentTerm === undefined || row.currentTerm === null || row.currentTerm === '0' ? '0' : '' + row.currentTerm;
      self.updateTermForm = Object.assign({}, row);
      self.updateTermForm.id = row.id;
      self.updateTermForm.startTime = self.formatTimeDate(row.startTime);
      self.updateTermForm.endTime = self.formatTimeDate(row.endTime);
      self.updateTermForm.termType = self.updateTermForm.termType.toString();
      self.updateTermForm.status = row.status;
      self.updateTermForm.schoolYear = row.schoolYear;
      self.upTermInfoVisible = true;
      self.checkboxDisabled();
    },
    saveTermInfo: function saveTermInfo() {
      var self = this;
      self.updateTermForm = {
        id: self.updateTermForm.id,
        name: self.updateTermForm.name,
        startTime: self.updateTermForm.startTime,
        endTime: self.updateTermForm.endTime,
        termType: self.updateTermForm.termType,
        status: self.updateTermForm.status,
        schoolYear: self.updateTermForm.schoolYear,
        currentTerm: self.updateTermForm.currentTerm
      };
      this.$refs.updateTermForm.validate(function (valid) {
        if (valid) {
          // 参数处理
          updateTermInfoBySchool(self.updateTermForm).then(function () {
            self.$notify.success('保存成功！');
            self.upTermInfoVisible = false;
            self.getTermList(1);
          }).catch(function () {});
        }
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getTermList(1);
  }
};